import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import { initNotifications } from './push/initNotifications';

// Initialize theme from localStorage
const savedTheme = localStorage.getItem('theme') || 'dark';
if (savedTheme === 'light') {
  document.documentElement.classList.add('theme-light');
} else {
  document.documentElement.classList.remove('theme-light');
}

// Initialize push notification system (registers service worker)
initNotifications().catch(console.error);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Hide loading screen
const loadingScreen = document.getElementById('loading-screen');
if (loadingScreen) {
  loadingScreen.classList.add('fade-out');
  setTimeout(() => loadingScreen.remove(), 300);
}

